<template>
    <div id="app">
        <router-view />
        <RecommendLayer v-if="isShowRecommendLayer"/>
    </div>
</template>

<script>
    import RecommendLayer from '@/components/recommend-layer/recommend-layer'
    import { urlSearchToObject } from '@/libs/tools'
    import { mapMutations } from 'vuex'
    export default {
        name: 'app',
        components: {
            RecommendLayer
        },
        mounted () {
            this.storeToken()
            // if (this.isPhone()) {
            //     window.location.href = '/reward' + this.$route.path
            // }
        },
        methods: {
            ...mapMutations(['setToken']),
            storeToken() {
                let token = urlSearchToObject().token
                let cookieToken = this.$store.state.user.token
                if (!token && !cookieToken) {
                    let href = window.location.href
                    window.location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(href)}`
                }
                if (token && token !== cookieToken) {
                    this.setToken(token)
                }
            }
        },
        computed: {
            isShowRecommendLayer () {
                return this.$store.state.app.isShowRecommendLayer
            }
        }
    }
</script>
